import React, { Component } from 'react'
import Api from '@api/localMerchant/NameCard'
import { observer, inject } from 'mobx-react'
import styles from './style.module.less'
@inject('parentStore')
@observer
export default class StepTwo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      manageUrl: ''
    }
  }
  async componentDidMount() {
    const { success, data } = await Api.merchantCardInfo()
    if (success) {
      this.setState({
        manageUrl: data.qrCode.shareMainCode
      })
    }
  }
  render() {
    return (
      <div className={styles['step-two']}>
        <div className={styles['step-two-header']}>
          <img
            src="https://qnm.hunliji.com/o_1dgu5kfgj1ke4elgmeb1nvj1v799.png"
            alt=""
          />
          <div className={styles['step-two-header-tip1']}>图片上传成功</div>
          <div className={styles['step-two-header-tip2']}>
            你现在可以通过【海草名片小程序】制作海报并分享给客户啦
          </div>
        </div>
        <div className={styles['step-two-body']}>
          <div className={styles['step-two-body-content']}>
            <img
              className={styles['step-two-body-img']}
              src="https://qnm.hunliji.com/o_1dgu7ta8rrgt8fm1e971the18ieo.png"
              width="100%"
            />
            {this.state.manageUrl ? (
              <img
                className={styles['step-two-body-qrcode']}
                src={this.state.manageUrl}
              />
            ) : null}
          </div>
        </div>
      </div>
    )
  }
}
